<template>
  <div>
    <div class="surveyBoxContainer">
      <h5>
        Q{{item.order}} {{item.question}} {{item.essential == 'Y' ? '' : '(선택)'}} 
      </h5>
      <div v-for="(option, index) in item.options" :key="index" class="flex surveyCheckBox">
        <label :for="linearId(index)">{{index + 1}}. {{option.data}} <span class="percent">({{option.percent}}%)</span></label>
      </div>
    </div>
  </div>
</template>

<script>
import {STATUS} from '@/data/survey'

export default {
  name: 'Linear',
  props:{
    status: null,
    item: null
  },
  data(){
    return{
      isOngoing: false,
      selected: null // Option Object
    }
  },
  mounted(){
    switch(this.status){
      case STATUS.ONGOING:
        this.isOngoing = true
        break
      default:
        this.isOngoing = false
        break
    }

    const selectedOptionIdx = (Number)(this.item.answer.data)
    const options = (this.item.options)

    for(var i = 0; i < options.length; i++){
      if(options[i].idx == selectedOptionIdx){
        this.selected = options[i]
        break
      }
    }
  },
  watch:{
    selected:{
      handler(selected){
        this.item.answer.data = selected.idx
      }
    }
  },
  methods:{
    linearId(index){
      return 'linear' + '_' + this.item.order + '_' + index
    }
  }
}
</script>